<script>
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import FormCreator from '../../UI/Form/FormCreator.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  components: { ButtonAll, FieldCreator, FormCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    simulation: { type: Object, default: {} },
    simulationClientId: { type: Number, default: '' },
    simulationId: { type: Number, default: '' },
    rent: { type: Object, default: {} },
    def: { type: Object, default: {} },
    isVisible: { type: Boolean, default: false },
  },

  data() {
    return {
      fields: [],
      noTitle: false,
      addBuyerValue: null,
      formData: null,
    }
  },

  watch: {
    isVisible: {
      handler() {
        this.setFields()
        $('#modal-accepted').modal('show')
      },
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    setFields: function () {
      if (
        this.def &&
        this.def.equipment &&
        this.def.equipment.brand &&
        this.def.equipment.brand.options &&
        !this.def.equipment.brand.options.display &&
        !this.def.equipment.model.options.display
      ) {
        this.noTitle = true
      }
      // this.$refs.acceptedField.defineFieldsFromConfig(
      //   this.fields,
      //   this.def,
      //   ["equipment.brand", "equipment.model", "buyer","language"]
      // );
      // this.$refs.acceptedField.setFieldsValues(
      //   this.fields,
      //   this.simulation
      // );
      // this.$refs.acceptedField.initModal();
    },
    addBuyer({ field, event }) {
      this.addBuyerValue = field.name == 'buyer' ? event : null
    },
    sendAccepted(checkBuyer) {
      let value = this.$refs.acceptedField.datas

      value['finance'] = {
        duration: this.rent.duration,
      }

      if (!this.addBuyerValue) {
        if (checkBuyer) {
          if (!value['buyer']) {
            alert(this.$root.$t('simulation.popin.proposal.userMissing'))
            return
          }
          value['target'] = 'client'
        }
      } else {
        value['buyer'] = this.addBuyerValue
      }

      this.patchJSON('quotations/' + this.simulationId + '/proposal', value, {}).then(
        function (json) {
          $('#modal-accepted').modal('hide')
        },
        function (reason) {
          alert(reason)
        },
      )
    },
    setDatas(json) {},
    isSending(bool) {},
  },
}
</script>
<template>
  <ModalDialog
    id="modal-accepted"
    id-modal-page="proposalbox"
    class-modal-dialog="modal-lg"
    title-t="simulation.popin.accepted.title"
    e2e-modal="accepted"
  >
    <template #body>
      <FormCreator
        @update-data="updateData"
        ref="acceptedField"
        src-error="acceptedField"
        endpoint="quotations"
        method="patch"
        :client-id="simulationClientId"
        :id="simulationId"
        :config-def="def"
        :config-object="simulation"
        :dynamic="true"
        :params="{ simulationId: simulationId }"
        class-to-add="d-none"
        @form-return="setDatas"
        @is-sending="isSending"
      ></FormCreator>
      <h5 v-if="!noTitle" class="text-center mt-3">{{ $t('simulation.popin.accepted.message') }}</h5>
      <template v-if="formData">
        <FieldCreator
          :form-data="formData"
          name="equipment.brand"
          form-ref="acceptedField"
          domain="simulation"
          :label-top="true"
        ></FieldCreator>
        <FieldCreator
          :form-data="formData"
          name="equipment.model"
          form-ref="acceptedField"
          domain="simulation"
          :label-top="true"
        ></FieldCreator>
        <FieldCreator
          :form-data="formData"
          name="buyer"
          form-ref="acceptedField"
          domain="simulation"
          :add-user="true"
          :simulation-id="simulationId"
          :entity-id="simulation.client.id"
          :label-top="true"
        ></FieldCreator>
        <FieldCreator
          :form-data="formData"
          name="language"
          form-ref="acceptedField"
          domain="simulation"
          :label-top="true"
          :add-user="true"
          :simulation-id="simulationId"
        ></FieldCreator>
      </template>
      <div class="text-danger text-center" style="font-weight: 500">{{ $t('simulation.popin.accepted.explain') }}</div>
    </template>
    <template #footer>
      <ButtonAll margin="no" type="information" data-dismiss="modal" label="button.cancel"></ButtonAll>
      <ButtonAll
        margin="no"
        type="validation"
        @click="sendAccepted(true)"
        label="simulation.popin.accepted.sendClient"
      ></ButtonAll>
      <ButtonAll
        margin="no"
        type="validation"
        @click="sendAccepted(false)"
        label="simulation.popin.accepted.send"
      ></ButtonAll>
    </template>
  </ModalDialog>
</template>
